export default __webpack_public_path__ + "static/media/top_w992up_1.28b8ced5.png";